var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1957_84225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 3C16.5046 2.99984 16.9906 3.19041 17.3605 3.5335C17.7305 3.87659 17.9572 4.34684 17.995 4.85L18 5V10H19.5C19.8729 10 20.2324 10.1389 20.5084 10.3896C20.7844 10.6403 20.9572 10.9848 20.993 11.356L21 11.5V19C21 19.7652 20.7077 20.5015 20.1827 21.0583C19.6578 21.615 18.9399 21.9501 18.176 21.995L18 22H5C4.49542 22.0002 4.00943 21.8096 3.63945 21.4665C3.26947 21.1234 3.04284 20.6532 3.005 20.15L3 20V5C2.99984 4.49542 3.19041 4.00943 3.5335 3.63945C3.87659 3.26947 4.34684 3.04284 4.85 3.005L5 3H16ZM19 12H18V20C18.2652 20 18.5196 19.8946 18.7071 19.7071C18.8946 19.5196 19 19.2652 19 19V12ZM11 13H8C7.74512 13.0003 7.49997 13.0979 7.31463 13.2728C7.1293 13.4478 7.01777 13.687 7.00283 13.9414C6.98789 14.1958 7.07067 14.4464 7.23426 14.6418C7.39786 14.8373 7.6299 14.9629 7.883 14.993L8 15H11C11.2549 14.9997 11.5 14.9021 11.6854 14.7272C11.8707 14.5522 11.9822 14.313 11.9972 14.0586C12.0121 13.8042 11.9293 13.5536 11.7657 13.3582C11.6021 13.1627 11.3701 13.0371 11.117 13.007L11 13ZM13 8H8C7.73478 8 7.48043 8.10536 7.29289 8.29289C7.10536 8.48043 7 8.73478 7 9C7 9.26522 7.10536 9.51957 7.29289 9.70711C7.48043 9.89464 7.73478 10 8 10H13C13.2652 10 13.5196 9.89464 13.7071 9.70711C13.8946 9.51957 14 9.26522 14 9C14 8.73478 13.8946 8.48043 13.7071 8.29289C13.5196 8.10536 13.2652 8 13 8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1957_84225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNews);
export default __webpack_public_path__ + "static/media/Ic_News.895a18214f67e4d40e4b6ed417c9ec3f.svg";
export { ForwardRef as ReactComponent };